<script setup lang="ts">

const { isMobileOpen, isOpen, menuItems } = useCollapse()
const app = useAppConfig()

const startMenuItems = computed(
  () =>
    menuItems.value?.filter(
      (sidebar) => !sidebar.position || sidebar.position === 'start',
    ),
)
const endMenuItems = computed(
  () => menuItems.value?.filter((sidebar) => sidebar.position === 'end'),
)

const navitemsWithChildren = ref([])
const onOpenChildren = (item) => {
  isOpen.value = true
  for (const [idx, navitem] of navitemsWithChildren.value.entries()) {

    if(navitem.isOpen == null){
      navitem.isOpen = false
    }

    if (navitem.item.name === item.name) {

    } else {
      navitem.isOpen = false
    }
  }
}

</script>

<template>
  <div :class="[
    !isOpen ? 'w-[80px]' : 'w-[280px]',
    isMobileOpen
      ? 'translate-x-0 lg:translate-x-0'
      : '-translate-x-full lg:translate-x-0',
  ]"
    class="dark:bg-muted-800 border-muted-200 dark:border-muted-700 fixed start-0 top-0 z-[60] flex h-full flex-col border-r bg-white transition-all duration-300">
    
    <slot name="header">
      <component :is="
          resolveComponentOrNative(
            app.tairo.collapse?.navigation?.header?.component,
          )
        " v-if="app.tairo.collapse?.navigation?.header?.component" />
    </slot>
    
    <div :class="!isOpen ? 'px-4' : 'px-6'"
      class="nui-slimscroll relative flex w-full grow flex-col overflow-y-auto py-6">
      
      <ul class="space-y-2" v-if="startMenuItems?.length">
        
        <li :key="index" v-for="(item, index) in startMenuItems">
          <component :is="resolveComponentOrNative(item?.component?.name)" v-if="item?.component?.name"
            v-bind="item?.component?.props" />
          <TairoCollapseNavigationCollapseLinks ref="navitemsWithChildren" :expanded="isOpen" :item="item" @clicked="onOpenChildren(item)"
            v-else-if="item.children" />
          <NuxtLink :class="!isOpen ? 'px-1 justify-center' : 'px-4'" :to="item.to"
            class="nui-focus text-muted-500 dark:text-muted-400/80 hover:bg-muted-100 dark:hover:bg-muted-700/60 hover:text-muted-600 dark:hover:text-muted-200 flex cursor-pointer items-center gap-4 rounded-lg py-3 transition-colors duration-300"
            exact-active-class="!bg-primary-500/10 dark:!bg-primary-500/20 !text-primary-500 dark:!text-primary-500"
            v-else-if="item.to">
            <Icon :class="item.icon.class" :name="item.icon.name" size="30px" />
            <span :class="!isOpen ? 'hidden' : 'block'" class="whitespace-nowrap font-sans text-sm">
              {{ item.name }}
            </span>
          </NuxtLink>
          <div class="border-muted-200 dark:border-muted-700 my-3 h-px w-full border-t" v-else-if="item.divider"></div>
          <button :class="!isOpen ? 'px-1 justify-center' : 'px-4'" @click="item.click"
            class="nui-focus text-muted-500 dark:text-muted-400/80 hover:bg-muted-100 dark:hover:bg-muted-700/60 hover:text-muted-600 dark:hover:text-muted-200 flex w-full cursor-pointer items-center gap-4 rounded-lg py-3 transition-colors duration-300"
            v-else>
            <Icon :class="item.icon.class" :name="item.icon.name" size="30px" />
            <span :class="!isOpen ? 'hidden' : 'block'" class="whitespace-nowrap font-sans text-sm">
              {{ item.name }}
            </span>
          </button>
        </li>
      </ul>
      <div class="mb-2 grow"></div>
      
      <ul class="space-y-2" v-if="endMenuItems?.length">
        
        <li :key="index" v-for="(item, index) in endMenuItems">
          <component :is="resolveComponentOrNative(item?.component?.name)" v-if="item?.component?.name"
            v-bind="item?.component?.props" />
          <TairoCollapseNavigationCollapseLinks :expanded="isOpen" :item="item" @clicked="isOpen = true"
            v-else-if="item.children" />
          <NuxtLink :class="!isOpen ? 'px-1 justify-center' : 'px-4'" :to="item.to"
            class="nui-focus text-muted-500 dark:text-muted-400/80 hover:bg-muted-100 dark:hover:bg-muted-700/60 hover:text-muted-600 dark:hover:text-muted-200 flex cursor-pointer items-center gap-4 rounded-lg py-3 transition-colors duration-300"
            exact-active-class="!bg-primary-500/10 dark:!bg-primary-500/20 !text-primary-500 dark:!text-primary-500"
            v-else-if="item.to">
            <Icon :class="item.icon.class" :name="item.icon.name" size="30px" />
            <span :class="!isOpen ? 'hidden' : 'block'" class="whitespace-nowrap font-sans text-sm">
              {{ item.name }}
            </span>
          </NuxtLink>
          <div class="border-muted-200 dark:border-muted-700 my-3 h-px w-full border-t" v-else-if="item.divider"></div>
          <button :class="!isOpen ? 'px-1 justify-center' : 'px-4'" @click="item.click"
            class="nui-focus text-muted-500 dark:text-muted-400/80 hover:bg-muted-100 dark:hover:bg-muted-700/60 hover:text-muted-600 dark:hover:text-muted-200 flex w-full cursor-pointer items-center gap-4 rounded-lg py-3 transition-colors duration-300"
            v-else>
            <Icon :class="item.icon.class" :name="item.icon.name" size="30px" />
            <span :class="!isOpen ? 'hidden' : 'block'" class="whitespace-nowrap font-sans text-sm">
              {{ item.name }}
            </span>
          </button>
        </li>
      </ul>
    </div>
    
    <slot name="footer">
      <component :is="
          resolveComponentOrNative(
            app.tairo.collapse?.navigation?.footer?.component,
          )
        " v-if="app.tairo.collapse?.navigation?.footer?.component" />
    </slot>
  </div>
</template>
